import React from 'react';
import { FormattedMessage } from 'react-intl';
import MoreMeeting from '../meeting/MoreMeeting';
import { DatePicker, Spin } from 'antd';
import moment from 'moment';
import {
  Chart,
  Geom,
  Tooltip,
  Legend,
  Coord,
  Label,
  View,
} from 'bizcharts';
import DataSet from '@antv/data-set';
import { RLS_KIND } from '../../utils/constants';

const { DataView } = DataSet;

export default ({ intl, dispatch, loading, meetingRelease }) => {
  const {
    startTime,
    endTime,
    meetingTreeData,
    meetingSearchInfo,
    chartData,
    legendData,
    rlsData
  } = meetingRelease;
  const {
    moreMeeting = []
  } = meetingSearchInfo;
  const meetingTree = meetingTreeData || { child: [] };

  const dv = new DataView();
  dv.source(chartData).transform({
    type: 'percent',
    field: 'num',
    dimension: 'rlsKind',
    as: 'percent'
  });
  const cols = {
    percent: {
      formatter: (val) => {
        val = `${(val * 100).toFixed(2)}%`;
        return val;
      }
    }
  };
  const dv1 = new DataView();
  dv1.source(chartData).transform({
    type: 'percent',
    field: 'num',
    dimension: 'rlsType',
    as: 'percent'
  });

  console.log("legendData", legendData)

  const {rlsKindColor = [], rlsTypeColor = []} = getChartColor(rlsData);

  return (
    <div className="message-body report-room report-container">
      {/*标题*/}
      {/*<div className="messages-first">
        <div className="nav">
          <a>{intl.formatMessage({ id: 'report_meeting_release_title' })}</a>
        </div>
      </div>*/}
      {/*主体*/}
      <div className="release-container">
        <Spin spinning={loading} size="large">
          {/*查询*/}
          <div className="messages-list roomReport room-report-title">
            <div className="messages-title roomReport-head releaseReport">
              <div className="report-div report-area">
                <label className="report-search-label">
                  <FormattedMessage id="report_area" />
                </label>
                <div className="search-input">
                  <span className="menu-border">
                    <i className="iconfont icon-sousuo" />
                    <MoreMeeting
                      meetingTree={meetingTree}
                      intl={intl}
                      placeHolder={intl.formatMessage({
                        id: 'report_room_place_holder'
                      })}
                      selected={moreMeeting}
                      onMeetingChange={v => {
                        // dispatch({type: 'top/setMeetingSearchInfo', meetingSearchInfo: {...meetingSearchInfo, moreMeeting: v}})
                        dispatch({
                          type: 'meetingRelease/setState',
                          payload: {
                            meetingSearchInfo: {
                              ...meetingSearchInfo,
                              moreMeeting: v
                            }
                          }
                        });
                      }}
                    />
                  </span>
                </div>
              </div>
              <div className="report-div report-date">
                <label className="report-search-label" >
                  <FormattedMessage id="report_date" />
                </label>
                <div>
                  <DatePicker
                    allowClear={false}
                    value={startTime}
                    disabledDate={current => {
                      return (
                        current.startOf('day').valueOf() >
                          endTime.startOf('day').valueOf()
                      )
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'meetingRelease/setState',
                        payload: { startTime: e.startOf('day') }
                      })
                    }}
                  />
                  ~
                  <DatePicker
                    allowClear={false}
                    value={endTime}
                    disabledDate={current => {
                      return (
                        startTime.valueOf() > current.valueOf() ||
                        current.startOf('day').valueOf() >
                          moment().startOf('day').valueOf()
                      )
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'meetingRelease/setState',
                        payload: { endTime: e.endOf('day') }
                      })
                    }}
                  />
                </div>
              </div>
              <div className="report-div report-btn-group">
                <button
                  className="button_primary"
                  onClick={() => {
                    dispatch({ type: 'meetingRelease/search' });
                  }}
                >
                  <FormattedMessage id="report_search" />
                </button>
              </div>
            </div>
          </div>

          <div
            className="messages-list meetingRelease room-report-table"
            style={{ height: '700px' }}
          >
            {
              chartData && chartData.length > 0 &&
              <div className="chart-container">
                <div className="chart-side">
                  <Chart
                    height={600}
                    data={dv}
                    scale={cols}
                    forceFit
                    className="release-chart"
                    padding="auto"
                  >
                    <Coord type="theta" radius={0.5} />
                    <Geom
                      type="intervalStack"
                      position="percent"
                      color={[
                        'rlsKind',
                        rlsKindColor
                      ]}
                      style={{
                        lineWidth: 1,
                        stroke: '#fff'
                      }}
                      select={false}
                    >
                      <Label content="rlsKind" offset={-10} />
                    </Geom>
                    <View data={dv1} scale={cols}>
                      <Coord type="theta" radius={0.75} innerRadius={0.5 / 0.75} />
                      <Geom
                        type="intervalStack"
                        position="percent"
                        color={[
                          'rlsType',
                          rlsTypeColor
                        ]}
                        style={{
                          lineWidth: 1,
                          stroke: '#fff'
                        }}
                        select={false}
                      >
                        <Label
                          content="rlsType"
                          htmlTemplate={(text, item, index)=>{
                          // text 为每条记录 x 属性的值
                          // item 为映射后的每条数据记录，是一个对象，可以从里面获取你想要的数据信息
                          // index 为每条记录的索引
                          var point = item.point; // 每个弧度对应的点
                          var percent = point['percent'];
                          percent = (percent * 100).toFixed(2) + '%';
                          // 自定义 html 模板
                          return `<span><span class='label-name'>${text}</span><span class='label-value'>${percent}</span></span>`
                          }}
                        />
                      </Geom>
                    </View>
                  </Chart>
                </div>
                <div className="legend-side">
                  {
                    legendData.map(l=>(
                      <div className="legend-item">
                        <span className="legend-color" style={{backgroundColor: `${l.color}`}} />
                        <span className="legend-name">{l.name}</span>
                        <span className="legend-percent">{`| ${l.percent}`}</span>
                        <span className="legend-num">{l.num}</span>
                      </div>
                    ))
                  }
                </div>
              </div>
            }
          </div>
        </Spin>
      </div>
    </div>
  );
};

/**
 * 为了保证色系纯正，对外圈的颜色进行深浅交替处理
 * @param rlsData
 * @return {{rlsKindColor: Array, rlsTypeColor: Array}}
 */
const getChartColor = (rlsData = []) => {
  let rlsKindColor = [], rlsTypeColor = [];
  rlsData.forEach((item, i) => {
    switch (item.rlsKind) {
      case RLS_KIND.cancel:
        if(!rlsKindColor.some(it => it === "#59CC75")){
          rlsKindColor.push("#59CC75");
        }
        rlsTypeColor.push(i%2 === 0 ? "#BAF5C4" : "#8EE0A1");
        break;
      case RLS_KIND.normal:
        if(!rlsKindColor.some(it => it === "#45A2FF")){
          rlsKindColor.push("#45A2FF");
        }
        rlsTypeColor.push(i%2 === 0 ? "#BAE7FF" : "#7FC9FE");
        break;
      case RLS_KIND.unsigned:
        if(!rlsKindColor.some(it => it === "#4DCBCB")){
          rlsKindColor.push("#4DCBCB");
        }
        rlsTypeColor.push(i%2 === 0 ? "#ABF5F5" : "#71E3E3");
        break;
    }
  });
  return {rlsKindColor, rlsTypeColor};
};



// WEBPACK FOOTER //
// ./src/components/report/ReleaseReport.js